import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { uploadFile, getFile } from "../../lib/ckeditor5";
class UploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  async upload() {
    try {
      const file = await this.loader.file;

      console.log("file", file);
      /*
      if (!file.name.includes(".png") || !file.name.includes(".jpg")  || !file.name.includes(".jpeg")  || !file.name.includes(".gif")) {
        window.alert("File does not support. You must use .png or .jpg ");
        return false;
     }
     */
     if (file.size > 5e6) {
       //window.alert("Please upload a file smaller than 5 MB");
       throw new Error("Please upload a file smaller than 5 MB");
     }

      // Generate a unique filename
      const filename = `${Date.now()}-${file.name}`;
      //console.log("filename",filename);
      
      // Step 1: Upload the file to Supabase using your helper function
      const uploadResponse = await uploadFile(filename, file);
      //console.log("File uploaded:", uploadResponse);

      // Step 2: Get the public URL of the file
      const publicUrlResponse = await getFile(filename);
      //console.log("Public file URL:", publicUrlResponse);

      // Ensure public URL is available
      if (publicUrlResponse.publicUrl) {
        // Step 3: Resolve with the URL so CKEditor can embed it
        return {
          default: publicUrlResponse.publicUrl, // Embed the public URL in CKEditor
        };
      } else {
        throw new Error("Failed to get public URL");
      }
    } catch (error) {
      console.error("Upload error:", error);
      throw error;
    }
  }

  abort() {
    // Handle abort case if needed
  }
}

// Custom plugin to add the upload adapter to CKEditor
function UploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new UploadAdapter(loader);
  };
}

const TextEditor = ({ value, setValue }) => {
  return (
    <CKEditor
      editor={ClassicEditor}
      data={value || ""}
      config={{
        extraPlugins: [UploadAdapterPlugin],
      }}
      onChange={(event, editor) => {
        setValue(editor.getData());
      }}
    />
  );
};

export default TextEditor;
